import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API_BASE_URL } from "../services/apiConfig";

const Login = ({ onLogin }) => {
  const navigate = useNavigate();
  const { hashcode } = useParams();

  const [step, setStep] = useState(1);
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // SEND OTP
  const handleSendOtp = async () => {
    if (phone.length !== 10) {
      setError("Enter a valid 10-digit phone number");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const res = await fetch(`${API_BASE_URL}/login-phone`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phone }),
      });

      const data = await res.json();

      if (data.status) {
        console.log(data);
        setStep(2);
      } else {
        setError(data.message || "Failed to send OTP");
      }
    } catch {
      setError("Server error. Try again.");
    } finally {
      setLoading(false);
    }
  };

  // VERIFY OTP
  const handleVerifyOtp = async () => {
    if (otp.length !== 6) {
      setError("Enter valid 6-digit OTP");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const res = await fetch(`${API_BASE_URL}/verify-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phone, otp }),
      });

      const data = await res.json();

      if (data.status) {
        localStorage.setItem("authToken", data.token);
        localStorage.setItem("user", JSON.stringify(data.user));

        onLogin(data.user);

        // Redirect back to table
        if (hashcode) {
          navigate(`/${hashcode}`);
        } else {
          navigate("/");
        }

      } else {
        setError(data.message || "Invalid OTP");
      }
    } catch {
      setError("Server error. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container pt-5">
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-4">
          <div className="card shadow">
            <div className="card-body p-4">
              <h4 className="text-center mb-4">
                Login to {hashcode ? "Continue Ordering" : "Restaurant"}
              </h4>

              {error && (
                <div className="alert alert-danger py-2">
                  {error}
                </div>
              )}

              {step === 1 && (
                <>
                  <label className="form-label">Phone Number</label>
                  <input
                    type="tel"
                    className="form-control mb-3"
                    placeholder="Enter 10-digit phone"
                    value={phone}
                    onChange={(e) =>
                      setPhone(e.target.value.replace(/\D/g, ""))
                    }
                    maxLength={10}
                  />

                  <button
                    className="btn btn-primary w-100"
                    onClick={handleSendOtp}
                    disabled={loading}
                  >
                    {loading ? "Sending OTP..." : "Send OTP"}
                  </button>
                </>
              )}

              {step === 2 && (
                <>
                  <p className="text-muted text-center">
                    OTP sent to <strong>{phone}</strong>
                  </p>

                  <label className="form-label">Enter OTP</label>
                  <input
                    type="text"
                    className="form-control mb-3 text-center"
                    placeholder="6-digit OTP"
                    value={otp}
                    onChange={(e) =>
                      setOtp(e.target.value.replace(/\D/g, ""))
                    }
                    maxLength={6}
                  />

                  <button
                    className="btn btn-success w-100 mb-2"
                    onClick={handleVerifyOtp}
                    disabled={loading}
                  >
                    {loading ? "Verifying..." : "Verify & Login"}
                  </button>

                  <button
                    className="btn btn-link w-100"
                    onClick={() => {
                      setStep(1);
                      setOtp("");
                    }}
                  >
                    Change phone number
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
